import { confirmLexicalStateInTextComponent } from 'modules/draftjs2lexical';
import { LexicalTextPreviewEditor } from 'modules/Lexical/components/LexicalTextPreviewEditor';
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Details } from 'components/Details';
import Icon from 'components/Icon';
import { IconType } from 'components/Icon/constants';
import { hideModal } from 'containers/ModalManager/actions';
import { selectedTextComponent } from 'containers/ProjectPanel/selectors';
import { intlGet } from 'utils/intlGet';
import styles from './styles.module.scss';

type Props = { modalWindowId: string };

const TextComponentDetails = (props: Props): JSX.Element => {
  const { modalWindowId } = props;

  const dispatch = useDispatch();
  const textComponent = useSelector(selectedTextComponent);

  const onClose = (): void => {
    dispatch(hideModal(modalWindowId));
  };

  const lexicalState = useMemo(() => {
    const component = confirmLexicalStateInTextComponent(textComponent, null);

    return component.get('lexicalState', null) ?? null;
  }, [textComponent]);

  return (
    <div className={styles.TextComponentDetails}>
      <Details
        onClose={onClose}
        title={intlGet('TextComponentDetails.Value', 'Title')}
      >
        <div className={styles.textInfo}>
          <Icon type={IconType.TEXT} size="sm-md" color="primary" />
          <div className={styles.htmlText}>
            <LexicalTextPreviewEditor editorState={lexicalState} />
          </div>
        </div>
      </Details>
    </div>
  );
};

export default TextComponentDetails;
